export default "__VITE_ASSET__13a22401__"